module.exports = __webpack_public_path__ + "static/img/coin.94c6865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/coin.png
// module id = tgek
// module chunks = 150